import GoExternal from '@clearkit/icons/glyphs/GoExternal';
import HubSpot from '@clearkit/icons/glyphs/Hubspot';
import map from 'lodash/map';

import { paginateField } from '~/lib/graphql/pagination';

import { keyColors } from './colors';
const color = keyColors.hubspot;
import Group from './Group';

const HubspotGroups = ({ search, hubspotCompanies }) => (
  <>
    {hubspotCompanies?.map((hubspotCompany, i) => {
      const { externalAccountId, id, name, properties } = hubspotCompany;
      const deals = paginateField(hubspotCompany, 'deals');
      return (
        <>
          <Group
            key={i}
            title={name}
            sections={[
              [{ label: 'Account Name', value: name }],
              [{ label: 'Deals', value: deals }],
              map(properties, (value, label) => {
                if (label === 'deals') return false;
                if (label === 'properties') return false;

                return { label, value };
              }),
            ]}
            icon={HubSpot}
            type={'hubspot'}
            search={search}
            actionLink={
              <a
                href={`https://app.hubspot.com/contacts/${externalAccountId}/company/${id}`}
                rel="noopener noreferrer"
                className="inline-flex align-center"
                style={{ color }}
                onClick={(e) => e.stopPropagation()}
                target="_blank">
                View in Hubspot
                <GoExternal className="ml-2" />
              </a>
            }
          />
          {deals?.map((deal) => (
            <Group
              key={deal.id}
              title={`Hubspot Deal – ${deal.name}`}
              sections={[
                [
                  { label: 'Name', value: deal.name },
                  { label: 'Amount', value: deal.amount },
                  {
                    label: 'Owner',
                    value: deal.owner?.name,
                  },
                ],
                map(deal.properties, (value, label) => ({ label, value })),
              ]}
              type="hubspot"
              search={search}
              icon={HubSpot}
              actionLink={
                <a
                  href={`https://app.hubspot.com/contacts/${externalAccountId}/deal/${deal.id}`}
                  rel="noopener noreferrer"
                  className="inline-flex align-center"
                  style={{ color }}
                  onClick={(e) => e.stopPropagation()}
                  target="_blank">
                  View in Hubspot
                  <GoExternal className="ml-2" />
                </a>
              }
            />
          ))}
        </>
      );
    })}
  </>
);

HubspotGroups.propTypes = {
  hubspotCompanies: PropTypes.arrayOf(
    PropTypes.shape({
      externalAccountId: PropTypes.string,
      id: PropTypes.string,
      name: PropTypes.string,
      properties: PropTypes.object,
      deals: PropTypes.array,
    }),
  ),
  search: PropTypes.string,
};

export default HubspotGroups;
